export default __webpack_public_path__ + "static/media/four.45bf4ce8.png";